import { post } from "../../api";

const fetchStoresList = body => post("storesList", {}, body);

export default fetchStoresList;
